import { COMPOSER } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  fetchSegmentsStatus: undefined,
  fetchStoriesStatus: undefined,
  segments: [],
  storyId: undefined,
  slides: [
    {
      number: 1,
      view: undefined,
      imageFile: undefined,
      segmentIds: [],
      imageUrl: undefined,
      presignedUrl: undefined,
    },
  ],
  selectedSlide: 0,
  addStoryStatus: undefined,
  addStoryError: undefined,
  editStoryStatus: undefined,
  editStoryError: undefined,
  deleteStoryStatus: undefined,
  deleteStoryError: undefined,
  dirty: false,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COMPOSER.FETCH_STORIES:
      return {
        ...state,
        fetchStoriesStatus: CONSTANTS.API.STARTED,
      };
    case COMPOSER.FETCH_STORIES_SUCCEEDED:
      return {
        ...state,
        storyId: action.payload.length > 0 ? action.payload[0].id : undefined,
        slides:
          action.payload.length > 0
            ? action.payload[0].slides.map(({ segments, ...rest }) => ({
                ...rest,
                segmentIds: segments.map(({ id: segmentId }) => segmentId),
              }))
            : state.slides,
        fetchStoriesStatus: CONSTANTS.API.SUCCEEDED,
      };
    case COMPOSER.FETCH_STORIES_FAILED:
      return {
        ...state,
        fetchStoriesStatus: CONSTANTS.API.FAILED,
      };
    case COMPOSER.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case COMPOSER.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case COMPOSER.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case COMPOSER.ADD_SLIDE:
      return {
        ...state,
        selectedSlide: state.slides.length,
        slides: [
          ...state.slides,
          {
            number: state.slides.length + 1,
            view: undefined,
            segmentIds: [],
            imageFile: undefined,
            imageUrl: undefined,
            presignedUrl: undefined,
          },
        ],
        dirty: true,
      };
    case COMPOSER.REMOVE_SLIDE:
      return state.slides.length === 1
        ? state
        : {
            ...state,
            selectedSlide:
              state.selectedSlide < action.payload
                ? state.selectedSlide
                : state.selectedSlide !== 0
                ? state.selectedSlide - 1
                : 0,
            slides: state.slides
              .map((slide, index) => ({
                ...slide,
                number: index <= action.payload ? slide.number : slide.number - 1,
              }))
              .filter((slide, index) => index !== action.payload),
            dirty: true,
          };
    case COMPOSER.MOVE_SLIDE:
      return {
        ...state,
        slides: state.slides.map((slide, index, items) => {
          if (index < action.payload.fromIndex && index < action.payload.toIndex) {
            return slide;
          }
          if (index === action.payload.toIndex) {
            return {
              ...items[action.payload.fromIndex],
              number: index + 1,
            };
          }
          if (index > action.payload.fromIndex && index > action.payload.toIndex) {
            return slide;
          }
          // got to move one place left or right
          if (action.payload.fromIndex > action.payload.toIndex) {
            return {
              ...items[index - 1],
              number: index + 1,
            };
          }
          return {
            ...items[index + 1],
            number: index + 1,
          };
        }),
        dirty: true,
      };
    case COMPOSER.SELECT_SLIDE:
      return {
        ...state,
        selectedSlide: action.payload,
      };
    case COMPOSER.SELECT_VIEW:
      return {
        ...state,
        slides: state.slides.map((slide, index) =>
          index === action.payload.index
            ? {
                ...slide,
                view: action.payload.view,
                segmentIds: slide.segmentIds.slice(0, CONSTANTS.VIEWS[action.payload.view].maxSegments),
              }
            : slide
        ),
        dirty: true,
      };
    case COMPOSER.SELECT_SEGMENT_IDS:
      return {
        ...state,
        slides: state.slides.map((slide, index) =>
          index === action.payload.index
            ? {
                ...slide,
                segmentIds: action.payload.segmentIds,
              }
            : slide
        ),
        dirty: true,
      };
    case COMPOSER.SELECT_IMAGE_FILE:
      return {
        ...state,
        slides: state.slides.map((slide, index) =>
          index === action.payload.index
            ? {
                ...slide,
                imageFile: action.payload.imageFile,
              }
            : slide
        ),
        dirty: true,
      };
    case COMPOSER.ADD_STORY:
      return {
        ...state,
        addStoryStatus: CONSTANTS.API.STARTED,
      };
    case COMPOSER.ADD_STORY_SUCCEEDED:
      return {
        ...state,
        addStoryStatus: CONSTANTS.API.SUCCEEDED,
        storyId: action.payload.id,
        dirty: false,
      };
    case COMPOSER.ADD_STORY_FAILED:
      return {
        ...state,
        addStoryStatus: CONSTANTS.API.FAILED,
        addStoryError: action.payload,
      };
    case COMPOSER.EDIT_STORY:
      return {
        ...state,
        editStoryStatus: CONSTANTS.API.STARTED,
      };
    case COMPOSER.EDIT_STORY_SUCCEEDED:
      return {
        ...state,
        editStoryStatus: CONSTANTS.API.SUCCEEDED,
        dirty: false,
      };
    case COMPOSER.EDIT_STORY_FAILED:
      return {
        ...state,
        editStoryStatus: CONSTANTS.API.FAILED,
        editStoryError: action.payload,
      };
    case COMPOSER.DELETE_STORY:
      return {
        ...state,
        deleteStoryStatus: CONSTANTS.API.STARTED,
      };
    case COMPOSER.DELETE_STORY_SUCCEEDED:
      return {
        ...state,
        deleteStoryStatus: CONSTANTS.API.SUCCEEDED,
        segments: [],
        storyId: undefined,
        slides: [
          {
            number: 1,
            view: undefined,
            imageFile: undefined,
            segmentIds: [],
            imageUrl: undefined,
            presignedUrl: undefined,
          },
        ],
        selectedSlide: 0,
      };
    case COMPOSER.DELETE_STORY_FAILED:
      return {
        ...state,
        deleteStoryStatus: CONSTANTS.API.FAILED,
        deleteStoryError: action.payload,
      };
    case COMPOSER.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    default:
      return state;
  }
};
